module.exports = __webpack_public_path__ + "static/media/bg-celeste.93681ab9.png";